import burger from "../elements/burger.js";
import sidebar from "../components/sidebar.js";

// Activa el botón hamburguesa ubicado en la barra de navegación, la cual tiene una animación de despliegue de menú.
window.addEventListener('load', burger);
window.addEventListener('load', sidebar);
// Escuchamos el evento resize para generar el slider cada vez que se redimensiona la ventana
window.addEventListener('resize', sidebar);